import React from "react";
import { useSelector } from "react-redux";
import MessageBubble from "./MessageBubble";

import WelcomyIcon from "../../../../../static/WelcomyIcon";

const Icon = () => {
  const hubLogo = useSelector((state) => state.hubConfig.hubLogo);
  if (hubLogo) {
    return <img src={hubLogo} className="bubble-icon" style={{
      width: "32px",
      height: "32px",
      objectFit: "scale-down",
      borderRadius: '50%',
      alignSelf: "center",
    }} />;
  }
  return <WelcomyIcon className="bubble-icon" />;
};

export const WelcomyMessage = ({ message, error }) => (
  <>
    <div className="server-message__wrapper">
      <Icon />
      <MessageBubble type="server" message={message} error={error} />
    </div>
  </>
);

const UserMessage = ({ message, error }) => (
  <MessageBubble type="user" message={message} error={error} />
);

function Conversation(props) {
  const conversation = useSelector(
    (state) => state.pdfConversation.conversation
  );
  return conversation.map((message, index) => {
    if (message.role === "user")
      return (
        <UserMessage
          message={message.content}
          error={message?.error}
          key={`user-${index}`}
        />
      );
    if (message.role === "assistant")
      return (
        <WelcomyMessage
          message={message.content}
          error={message?.error}
          key={`welcomy-${index}`}
        />
      );
  });
}

export default Conversation;
